<template>
  <div id="app" class="container" style="overflow-x: hidden">
    <div class="balck" @click="goHome">
      <img src="../../assets/css/icon/fh.png" alt="">
      <span>{{ $t("return") }}</span>
    </div>
    <!--    <div id="main"></div>-->
    <div class="userInfo_box">
      <div class="left_box">
        <div class="user_info_box" >
          <img :src="userInfo.userImg" class="rounded-full" @click="goApply">
          <div class="other_box" @click="goApply">
            <div class="name">{{ userInfo.username }}</div>
            <div class="text pc_text_box" v-html="userInfo.text"></div>
            <div class="mobile_text_box">
              <div class="text" v-show="mobileTextShow===false">
                {{ userInfo.text.length > 15 ? userInfo.text.substring(0, 15) + '...' : userInfo.text }}
              </div>
              <div class="text" v-show="mobileTextShow===true">{{ userInfo.text }}</div>
              <div class="btn_icon" @click="mobileTextShow = !mobileTextShow">
                <i v-show="mobileTextShow===false" class="el-collapse-item__arrow el-icon-arrow-down"></i>
                <i v-show="mobileTextShow===true" class="el-collapse-item__arrow el-icon-arrow-up"></i>
              </div>
            </div>
            <!--            <div class="text_btn" @click="isTrue()">查看译文</div>-->
          </div>
        </div>
        <div class="number_box">
          <div><span>{{ $t("trading_days") }}</span>{{ userInfo.days }}</div>
          <div>
            <el-tooltip placement="top" :open-delay="1000" effect="light">
              <div class="content_text" slot="content">{{ $t('copy_traders2') }}
              </div>
              <span class="solid">{{ $t("copy_traders") }}</span>
            </el-tooltip>
            {{ userInfo.followCount }}
          </div>
          <div>
            <el-tooltip placement="top" :open-delay="1000" effect="light">
              <div class="content_text" slot="content">{{ $t('total_copy_traders2') }}
              </div>
              <span class="solid">{{ $t("total_copy_traders") }}</span>
            </el-tooltip>
            {{ userInfo.allFollowCount }}
          </div>
        </div>
      </div>
      <div class="right_box">
        <div class="function_box mobile_none" v-if="false">
          <img src="../../assets/css/icon/fenxiang.png" alt="">

        </div>
        <div class="delete_icon">
          <img src="../../assets/imgs/share.svg" @click="shareOpen"/>
          <svg v-if="showOrder" @click="dialogVisible=true" t="1745750561104" class="icon" style="margin-top: 31px"
               viewBox="0 0 1024 1024" version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="3208" width="200" height="200">
            <path
                d="M751 157.4c45.2 6.4 92.2-1.8 129.1 4.5 59.7 10.2 90 61 83.5 135.8h-72.3c-2 132.7-1.1 264.1-1.1 397.3 0 67.2 5.6 137.8-1.1 198.1-6.3 56.9-48.1 91.6-99 100.1-50.3 8.4-117 2.2-172.5 2.2-116.4 0-234.3 2.3-348.3 0-55.5-1.1-96.5-18.7-121.3-52.3-24.8-33.6-22.3-84.4-22.3-144.7V297.7h-69c-11.2-68.8 18.6-118.3 69-134.6 37.1-12 86.5-2.3 139.1-5.6-4.3-74.1-0.2-130.3 63.4-138 28.5-3.4 66.5 0 101.3 0H632c38.6 0 78.1-3.7 97.9 13.4 27.3 23.5 20.2 78 21.1 124.5zM333.7 92.8v66.8H682V89.5H334.8c-1.3 0.2-1.2 1.7-1.1 3.3z m-67.9 212.6v424c0 36.2-8.3 113.4 13.4 129.1 8.6 6.2 30.9 7.2 41.2 0 22.4-15.6 14.5-90.6 14.5-128V302.1H267c-1.4 0.1-1.3 1.7-1.2 3.3z m207 0V716c0 32.4-7.5 109.1 5.6 131.3 8.6 14.7 37.8 21.3 52.3 10 19.7-15.4 11.1-96.6 11.1-130.2V302h-67.9c-1.3 0.2-1.2 1.8-1.1 3.4z m209.2 0v429.5c0 44-8.6 111.5 20 123.5 12.5 5.3 34.6 1.2 40.1-3.3 18.7-15.4 10-97.8 10-130.2V302.1h-69c-1.3 0.1-1.2 1.7-1.1 3.3z"
                fill="#EAECEF" p-id="3209">
            </path>
          </svg>
        </div>
      </div>
    </div>
    <div class="data_content ">
      <div class="item">
        <div class="des">{{$t("leader_overview")}}</div>
        <div class="item_f">
          <div>
            <div class="title">{{$t('signal_provider_address')}}</div>
            <div class="value" style="margin-bottom: 15px;">{{userInfo.trader}}</div>
          </div>
        </div>
        <div class="item_f">
          <div>
            <div class="title">{{$t('settlement_currency')}}</div>
            <div class="value">{{symbol}}</div>
          </div>
          <div style="width: 60%;">
            <div class="title right">{{$t('settlement_address')}}</div>
            <div class="value right">{{token}}</div>
          </div>
        </div>
      </div>

      <div class="item">
        <div class="des">{{$t("project_performance")}}</div>
        <div class="item_f">
          <div>
            <div class="title">{{$t('unrealized_profit_loss')}}</div>
            <div :class="'value ' +(parseFloat(unpnl)>=0?'long':'short')">{{unpnl.toFixed(2)}}({{unpnlRate}}%)</div>
          </div>
          <div>
            <div class="title right">{{ $t('realized_profit_loss') }}</div>
            <div :class="'value right '+(parseFloat(totalProfit)>0?'long':'short')">{{totalProfit.toFixed(2)}}</div>
          </div>
        </div>
        <div class="item_f">
          <div>
            <div class="title right">{{$t("aum")}}</div>
            <div class="value right">{{total}}</div>
          </div>
          <div>
            <div class="title right">{{$t("profit_sharing_ratio")}}</div>
            <div class="value right">{{rate}}%</div>
          </div>
          <div>
            <div class="title right">{{$t('profit_received')}}</div>
            <div class="value right">{{disProfit.toFixed(2)}}</div>
          </div>
        </div>
      </div>

      <div class="item">
        <div class="des">{{$t('account_amount')}}</div>
        <div class="item_f">
          <div>
            <div class="title">{{$t('available_balance')}}</div>
            <div class="value">{{balance}}</div>
          </div>
          <div>
            <div class="title right">{{$t('shareValue')}}</div>
            <div class="value right">{{shareRate}}</div>
          </div>
        </div>
        <div class="item_f">
          <div>
            <div class="title">{{$t('total_margin')}}</div>
            <div class="value">{{margin}}</div>
          </div>
          <div>
            <div class="title right">{{$t('total_margin_ratio')}}</div>
            <div class="value right">{{marginRate}}%</div>
          </div>
        </div>
      </div>
    </div>
    <div class="table_conent" id="table_content">
      <div class="tab_box">
        <div class="tab_list" @click="activateClick(0)" :class="activate===0?'activate':''">{{
            $t("current_position")
          }}
        </div>
        <div class="tab_list" @click="activateClick(1)" :class="activate===1?'activate':''">{{ $t("current_orders") }}
        </div>
        <div class="tab_list" v-if="showOrder" @click="activateClick(4)" :class="activate===4?'activate':''">
          {{ $t("place_order") }}
        </div>
        <div class="tab_list" @click="activateClick(2)" :class="activate===2?'activate':''">{{ $t("trade_history") }}
        </div>
        <div class="tab_list" @click="activateClick(8)" :class="activate===8?'activate':''">{{$t('order_history')}}
        </div>
        <div class="tab_list" @click="activateClick(3)" :class="activate===3?'activate':''">
          {{ $t("copy_trading") }}
        </div>
        <!--        <div class="tab_list" @click="activateClick(4)" v-if="showOrder" :class="activate===4?'activate':''">{{$t("place_order")}}</div>-->
        <!--        <div class="tab_list" @click="activateClick(5)" :class="activate===5?'activate':''">参数设置</div>-->
        <div class="tab_list" @click="activateClick(6)" :class="activate===6?'activate':''">
          {{ $t("copy_trader_list") }}
        </div>
        <div class="tab_list" @click="activateClick(7)" v-if="showOrder" :class="activate===7?'activate':''">
          {{ $t("pending_withdrawal_users") }}
        </div>
        <div class="tab_list refresh_icon" @click="refresh()">
          <svg t="1745751567117" class="icon" viewBox="0 0 1162 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
               p-id="4279" width="200" height="200">
            <path
                d="M1015.265248 720.230902h-8.677481a34.709923 34.709923 0 0 1-26.032442-52.064884 433.874038 433.874038 0 0 0-216.937019-538.003807 425.196557 425.196557 0 0 0-485.938922 86.774808 43.387404 43.387404 0 0 1-60.742365-60.742365A520.648845 520.648845 0 0 1 807.00571 52.064885 511.971364 511.971364 0 0 1 1058.652652 694.19846a43.387404 43.387404 0 0 1-43.387404 26.032442zM581.39121 1023.942729a538.003807 538.003807 0 0 1-225.614499-52.064885 520.648845 520.648845 0 0 1-260.324423-624.778614 43.387404 43.387404 0 0 1 60.742366-26.032442 43.387404 43.387404 0 0 1 26.032442 52.064884 433.874038 433.874038 0 0 0 216.937019 520.648845 425.196557 425.196557 0 0 0 485.938922-86.774807 43.387404 43.387404 0 1 1 60.742365 60.742365 485.938922 485.938922 0 0 1-364.454192 156.194654z"
                fill="#848E9C" p-id="4280"></path>
            <path
                d="M199.582057 494.616403c-17.354962 0-26.032442 0-34.709923-17.354962l-34.709923-52.064884-60.742365 52.064884a43.387404 43.387404 0 0 1-60.742365-8.67748 43.387404 43.387404 0 0 1 8.677481-60.742366l95.452288-78.097326c8.677481-8.677481 26.032442-17.354962 34.709923-8.677481s26.032442 8.677481 26.032442 17.354961L234.29198 433.874038c17.354962 17.354962 8.677481 43.387404-17.354961 60.742365zM1015.265248 746.263345h-8.677481l-26.032442-26.032443-52.064885-95.452288c-17.354962-17.354962-8.677481-43.387404 17.354962-60.742365a60.742365 60.742365 0 0 1 60.742365 17.354961l26.032442 60.742366 60.742366-52.064885a52.064885 52.064885 0 0 1 60.742365 8.677481c8.677481 17.354962 8.677481 52.064885-8.677481 60.742365l-104.129769 78.097327z"
                fill="#848E9C" p-id="4281"></path>
          </svg>
        </div>
      </div>
      <activate0 ref="active0" v-show="activate===0" @pan-total="updatePan"
                 :contract-address="this.$route.query.contract" :token="this.$route.query.token"></activate0>
      <activate1 ref="active1" v-show="activate===1" @refresh-data="refreshData"
                 :contract-address="this.$route.query.contract" :token="this.$route.query.token"></activate1>
      <activate2 ref="active2" v-show="activate===2" :contract-address="this.$route.query.contract"
                 :token="this.$route.query.token"></activate2>
      <activate3 ref="active3" v-show="activate===3" @refresh-data="refreshData"
                 :contract-address="this.$route.query.contract" :token="this.$route.query.token"></activate3>
      <activate4_2 ref="active4" v-show="activate===4" v-if="showOrder" @refresh-data="refreshData"
                 :contract-address="this.$route.query.contract" :token="this.$route.query.token"></activate4_2>
      <!--      <activate5 v-show="activate===5" :contract-address="this.$route.query.contract"></activate5>-->
      <activate6 ref="active6" v-show="activate===6" :contract-address="this.$route.query.contract"
                 :token="this.$route.query.token"></activate6>
      <activate7 ref="active7" v-show="activate===7" :contract-address="this.$route.query.contract"
                 :token="this.$route.query.token"></activate7>
      <activate8 ref="active8" v-show="activate===8" :contract-address="this.$route.query.contract"
                 :token="this.$route.query.token"></activate8>
    </div>
    <el-dialog :modal="false" style="margin-top: 24vh" class="delete_dialog" :show-close="false"
               :visible.sync="dialogVisible" width="380px">
      <div class="text_box">
        {{ $t('confirm_delete') }}
      </div>
      <span slot="footer" class="dialog_footer_box">
        <el-button style="background: #C6FE61;color: #181A20" type="primary"
                   @click="ok1()">{{ $t("confirm") }}</el-button>
        <el-button class="cancel_box" @click="dialogVisible = false">{{ $t("cancel") }}</el-button>
      </span>
    </el-dialog>
    <share ref="share" :contract="this.$route.query.contract" :token="this.$route.query.token"></share>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import activate0 from '../../components/activate0'
import activate1 from '../../components/activate1'
import activate2 from '../../components/activate2'
import activate3 from '../../components/activate3'
import activate4 from '../../components/activate4'
import activate5 from '../../components/activate5'
import activate6 from '../../components/activate6'
import activate7 from '../../components/activate7'
import NoAxisLineChart from '../../components/NoAxisLineChart';

import {
  createAndCall,
  createLeadingContractAndCall,
  createLeadingContractAndSend, createPerpOptionAndCall, getContractWithCache,
  getErc20Info, getGasReward, getSelectTokenInfo
} from "../../utils/contract";
import {Contract, Method, Underling} from "../../config/const";
import {BIG_ZERO, isMobile, transBig2number, transNumber2Big} from "../../utils/functions";
import {BigNumber, ethers} from "ethers";
import {getAssetInfo, getDisProfit, getHistoryData, getOrderCountInfo, getTransData} from "../../service/queryService";
import {getLastPrice} from "../../service/priceService";
import config from "../../config/config";
import {getAccount, getChainId, requestAccount} from "../../utils/wallet";
import {getDotAddress} from "../../utils/strings";
import Share from "../../components/share.vue";
import Activate8 from "../../components/activate8.vue";
import activate4_2 from "../../components/activate4_2.vue";
import {emmitMessage, MESSAGE} from "../../utils/message";

export default {
  components: {
    Activate8,
    Share,
    activate0,
    activate1,
    activate2,
    activate3,
    activate4,
    activate4_2,
    activate5,
    activate6,
    activate7,

    NoAxisLineChart
  },
  data() {
    return {
      isDragging: false,
      sliderWidth: 0,
      handleLeft: 0,
      containerWidth: 300, // Width of the slider container
      share: 553,
      balance: 0,
      total: 0,
      rate: 0,
      symbol: "",
      profitValue: '7',
      assetValue: '7',
      winPosition: "0",
      profitRate: "0",
      disProfit:0,
      userInfo: {
        username: '',
        userImg: require('../../assets/css/icon/head.svg'),
        type: 0,
        number: '',
        yield: '',
        scale: '',
        day7: '',
        currency: [{label: 'USTD', value: 0}, {label: 'US00TD', value: 1}],
        molecule: '102',
        denominator: '400',
        text: '',
        text2: '',
        isT: false,
        days: 0,
        followCount: 0,
        allFollowCount: 0,
        trader:"",
      },
      options: [
        {
          value: '1',
          label: this.$t('today')
        }, {
          value: '7',
          label: this.$t('one_week')
        }, {
          value: '15',
          label: this.$t('half_month')
        }, {
          value: '30',
          label: this.$t('thirty_days')
        }
      ],
      value: '7',

      activate: 4,
      margin: 0,
      marginRate: 0,

      up: {
        input1: '',
        name: '',
        adress: '',
        num: '',
        price: '',
      },
      stop: {
        up: 0,
        down: 0
      },
      currentPage: 1,
      tapActive: 0,
      contractAddress: "",
      token: "",
      dotToken: "",
      myChart: undefined,
      myChart2: undefined,
      myChart3: undefined,
      dialogVisible: false,
      //todo
      showOrder: false,
      interval: undefined,
      interval2: undefined,
      shareAmount: "",
      shareRate: "",
      chartData1: [0, 0, 0, 0, 0, 0],
      mobileTextShow: false,
      totalPosition: 0,
      unpnl: 0,
      totalProfit: 0,
      unpnlRate: 0
    };
  },

  created() {
    let isFollow=this.$route.query.follow;
    if(isFollow){
      this.tapActive=3;
    }
    this.created()
  },

  mounted() {
    this.contractAddress = this.$route.query.contract;
    this.token = this.$route.query.token;
    this.interval = setInterval(() => {
      this.init()
    }, 30000);
    window.addEventListener("resize", this.resize)
    this.resize()
    this.getUserInfo()
  },
  unmounted() {
    if (this.interval) {
      clearInterval(this.interval)
      clearInterval(this.interval2)
    }
    window.removeEventListener("resize")
  },
  methods: {
    async created() {
      await requestAccount()
      this.contractAddress = this.$route.query.contract;
      this.token = this.$route.query.token;
      this.dotToken = getDotAddress(this.token)
      if (window.location.href.indexOf("#table_content") === -1) {
        this.activate = 0;
      }
      this.init()
      setTimeout(() => {
        this.$refs["active" + this.activate].init();
      }, 500);
    },
    resize() {
      if (document.body.clientWidth < 750) {
        window.location.href = "/#/listMobile?contract=" + this.$route.query.contract + "&token=" + this.$route.query.token;
      }
    },
    init() {
      this.getInfo()
      this.getProjectInfo()
      this.getAssetInfo()
      this.getDisProfit()
    },
    async getUserInfo(){
      if (!this.contractAddress || !this.token) {
        return;
      }
      let info =await getContractWithCache([Contract.LeadingContractFactory, Method.getLeadingContractInfoByAddress, [this.contractAddress]],3600000,createAndCall);
      this.userInfo.username = info.traderName

      const des=info.traderDescription;
      const desArr=des.split("$^");
      let headUrl="";
      if(desArr.length>1){
        headUrl=desArr[desArr.length-1];
      }
      if(headUrl){
        if(headUrl.startsWith("http")){
          this.userInfo.userImg=headUrl;
        }else{
          this.userInfo.userImg="https://admin.fufuture.io"+headUrl;
        }
      }
      this.userInfo.text = this.parseHtml(desArr[0] ? desArr[0] : "--")

      let createTime = parseInt(info.createTime.toString());
      let days = Math.ceil(((new Date().getTime() / 1000) - createTime) / 86400);
      this.userInfo.days = days;
      this.userInfo.trader=info.traderAddress;
      let account = await getAccount()
      if (account.toLowerCase() === info.traderAddress.toLowerCase()) {
        this.showOrder = true;
      }
    },
    async getInfo() {
      if (!this.contractAddress || !this.token) {
        return;
      }

      let followAllInfo = await createLeadingContractAndCall(this.contractAddress, Method.getAllFollowers)
      this.userInfo.allFollowCount = followAllInfo.length;

      let followInfo = await createLeadingContractAndCall(this.contractAddress, Method.getFollowerCount);
      this.userInfo.followCount = followInfo.toString();

    },
    calcuRate(order) {
      if (order.orderType == 1 || order.orderType == 2) {
        return "0";
      }

      let sub = BigNumber.from(0);
      if (order.direction == 1) {
        sub = BigNumber.from(order.price).sub(BigNumber.from(order.costPrice));
      } else {
        sub = BigNumber.from(order.costPrice).sub(BigNumber.from(order.price));
      }

      return transBig2number(sub.mul(order.amount).div(BigNumber.from("1000000000000000000")));
    },
    parseHtml(content) {

      return content.replace("\n", "<br/>");
    },
    updatePan(value, total) {
      this.margin = parseFloat(value.margin).toFixed(2);
      if (!value.pan) {
        this.marginRate = 0;
      } else {
        if (Number(value.margin) === 0) {
          this.marginRate = 0;
        } else {
          this.marginRate = Number(value.marginRate)
        }
      }
      this.unpnl = parseFloat(value.pan);
      this.totalPosition = Number(total).toFixed(2);
      if (Number(value.marginRate) > 0) {
        this.unpnlRate = (this.unpnl * 100 / parseFloat(value.margin)).toFixed(2)
      }

      if(this.$refs.share){
        this.$refs.share.update(this.total,this.unpnl,this.totalProfit)
      }


    },
    isTrue() {
      this.userInfo.isT = !this.userInfo.isT
    },
    activateClick(n) {
      this.activate = n;
      this.$refs["active" + n].init();
      if (this.$refs["active4"]) {
        this.$refs["active4"].setStop(n == 4);
      }

    },



    async getProjectInfo() {

      let selectToken = await getSelectTokenInfo(this.token)
      this.symbol = selectToken.symbol

      let price = await getLastPrice()
      let priceBTC = transBig2number(price[Underling.BTC].price, price[Underling.BTC].decimal, 6);
      let priceETH = transBig2number(price[Underling.ETH].price, price[Underling.ETH].decimal, 6);
      let priceSOL = transBig2number(price[Underling.SOL].price, price[Underling.SOL].decimal, 6);

      let priceBtcNum = transNumber2Big(priceBTC);
      let priceEthNum = transNumber2Big(priceETH);
      let priceSOLNum = transNumber2Big(priceSOL);
      // let asset = await createLeadingContractAndCall(this.contractAddress, Method.getTotalBalance, [Underling.BTC, Underling.ETH,Underling.SOL], [priceBtcNum, priceEthNum,priceSOL]);

      let asset=await getContractWithCache([this.contractAddress, Method.getTotalBalance,[[Underling.BTC, Underling.ETH,Underling.SOL], [priceBtcNum, priceEthNum,priceSOLNum]]],10000,createLeadingContractAndCall)

      let accountInfo=await getContractWithCache([selectToken.perpetual, Method.getAccountInfo,[this.token, this.contractAddress]],10000,createPerpOptionAndCall)

      let balance=0;
      if (asset.gainLoss) {
        balance =parseFloat(transBig2number(accountInfo.availableAmount))
      } else {
        balance = parseFloat(transBig2number(accountInfo.availableAmount.sub(asset.profit)))
      }

      if(balance>=0){
        this.balance=balance;
      }else{
        this.balance=0;
      }

      this.total = transBig2number(asset.assetAmount);


      this.margin = transBig2number(accountInfo.marginAmount)

      // let rate = await createLeadingContractAndCall(this.contractAddress, Method.commissionRate);
      let rate = await getContractWithCache([this.contractAddress, Method.commissionRate,[]],100000,createLeadingContractAndCall);

      this.rate = rate.toString();

      // let totalShare = await createLeadingContractAndCall(this.contractAddress, Method.totalShare);
      let totalShare = await getContractWithCache([this.contractAddress, Method.totalShare,[]],100000,createLeadingContractAndCall);


      if (totalShare.eq(BigNumber.from(0))) {
        this.shareRate = "0";
      } else {
        let shareValue = asset.assetAmount.mul(BigNumber.from(10000)).div(totalShare)
        this.shareRate = (parseFloat(shareValue.toString()) / 10000);
      }


      let logs = await getHistoryData(this.contractAddress, 0);
      let profit = 0;
      let winPosition = 0;
      for (let i in logs.orderHistories) {
        let item = logs.orderHistories[i];
        let profitItem = parseFloat(this.calcuRate(item));
        if (profitItem > 0) {
          winPosition += profitItem;
        }
        profit += profitItem;
        let fee = parseFloat(transBig2number(item.tradingFee));
        profit -= fee
      }
      this.winPosition = winPosition.toFixed(2);

      if(!isNaN(profit)){
        this.totalProfit = profit;
      }

      if(this.$refs.share){
        this.$refs.share.update(this.total,this.unpnl,this.totalProfit)
      }

    },

    async getAssetInfo() {
      let assetInfo = [50, 50];

      assetInfo = await getAssetInfo(this.contractAddress, parseInt(this.assetValue));

      let price = await getLastPrice();
      let btcPrice = transBig2number(price[Underling.BTC].price, price[Underling.BTC].decimal);
      let ethPrice = transBig2number(price[Underling.ETH].price, price[Underling.ETH].decimal);

      let btcValue = parseFloat(btcPrice) * parseFloat(assetInfo[0])
      let ethValue = parseFloat(ethPrice) * parseFloat(assetInfo[1])

      let rateBtc = 0;
      let rateEth = 0;
      if (btcValue !== 0 || ethValue !== 0) {
        rateBtc = parseFloat((btcValue / (btcValue + ethValue) * 100).toFixed(2));
        rateEth = parseFloat((100 - rateBtc).toFixed(2));
      }

    },

    async ok1() {
      this.dialogVisible = false
      let price = await getLastPrice();
      let chainId = await getChainId();
      // let tigger=await getGasReward(this.token,Underling.ETH);
      let tx = await createLeadingContractAndSend(this.contractAddress, Method.traderDeleteContract, [["BTC", "ETH"], [ethers.utils.arrayify(price[Underling.BTC].hex), ethers.utils.arrayify(price[Underling.ETH].hex)]], config[chainId].verifyValue)
      if (tx) {
        this.$router.push({path: '/'})
      }
    },
    async getDisProfit(){
      let data=await getDisProfit(this.contractAddress.toLowerCase());
      if(!data.profitsDistributeds || data.profitsDistributeds.length==0){
        return ;
      }
      let total=BigNumber.from(0);
      for(let i in data.profitsDistributeds){
        let item=data.profitsDistributeds[i];
        total=total.add(BigNumber.from(item.paidDistribute))
      }
      this.disProfit=parseFloat(transBig2number(total));
    },
    refresh() {
      this.$refs["active" + this.activate].init();
    },
    refreshData() {
      this.getProjectInfo();
      this.$refs.active0.init()
      this.$refs.active1.init()
      this.$refs.active3.init()
    },
    shareOpen() {
      if(this.$refs.share){
        this.$refs.share.show(this.userInfo.username,this.total,this.unpnl,this.totalProfit);
      }
    },
    goHome(){
      //this.$router.push("/")
      window.location.href="/";
    },
    async goApply(){
      let tokenInfo=await getSelectTokenInfo(this.token);
      this.$router.push({ path: '/applyFor',query:{contract:this.contractAddress,token:this.token,name:this.userInfo.username,avatar:this.userInfo.userImg,des:this.userInfo.text,tokenName:tokenInfo.symbol,rate:this.rate}})
    },
  },

  watch: {
    profitValue() {
    },
    assetValue() {
      this.getAssetInfo()
    },
    value() {
      this.getProjectInfo()
    }
  }
};
</script>
<style src="../../assets/css/celect.css"></style>
<style src="../../assets/css/index.scss" lang="scss" scoped></style>
<style src="../../assets/list.scss" lang="scss" scoped></style>
<style src="../../assets/windows.scss" lang="scss" scoped></style>
<style src="../../assets/css/mobile.scss" lang="scss" scoped></style>

<style lang="scss" scoped>
.aaatext {
  font-size: 12px;
  font-weight: 500;;
  position: absolute;
  color: rgba(132, 142, 156, 1);
  bottom: 32px;
}


.slider-container {
  width: 300px;
  height: 20px;
  background-color: #ccc;
  position: relative;
  margin: 50px;
}

.slider-bar {
  height: 100%;
  width: 0; /* This will be updated dynamically */
  background-color: green;
  position: absolute;
  left: 0;
  top: 0;
}

.slider-handle {
  width: 30px;
  height: 30px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0; /* This will be updated dynamically */
  cursor: pointer;
}

::v-deep .delete_dialog .el-dialog__header {
  padding: 0 !important;
}

::v-deep .delete_dialog .el-dialog__body {
  padding: 18px 20px !important;

}

.text_box {
  color: #ffffff;
  font-weight: 400;
  font-size: 15px;
}

.refresh_icon {
  cursor: pointer;

  svg {
    width: 17px;
    height: 17px;
  }

}

.content_text {
  color: #181A20;
}

::v-deep .el-tooltip__popper.is-light {
  border: 0 !important;
}

.right-content {
  font-weight: 500;
  font-size: 15px;
}

.list {
  justify-content: space-between;

  .right {
    max-width: 50%;
  }
}

.data_content {
  display: flex;
  gap: 26px;

  .item {
    width: 382px;
    height: 230px;
    border: 1px solid rgba(234, 236, 239, 0.2);
    border-radius: 16px;
    padding-left: 25px;
    padding-top:25px;
    padding-right: 25px;

    .des {
      font-size: 20px;
      font-weight: 700;
      letter-spacing: 0px;
      line-height: 23.44px;
      color: rgba(234, 236, 239, 1);
      margin-bottom: 30px;
    }

    .item_f {
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 16.41px;
        color: rgba(132, 142, 156, 1);
        margin-bottom: 12px;
      }

      .value {
        font-size: 15px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 17.58px;
        color: rgba(234, 236, 239, 1);
        margin-bottom: 30px;
        word-break: break-all;
      }
      .right{
        text-align: right;
      }
    }
  }
}
.long{
  color:rgba(46, 189, 133, 1);
}
.short{
  color:rgba(239, 69, 74, 1);
}

@media (max-width: 750px) {
  .right-content {
    font-size: 12px;
  }

}


</style>
<style src="../../assets/css/mobile.scss" lang="scss" scoped></style>
<style scoped lang="scss">
.select_down {
  ::v-deep .el-input__suffix {
    .el-input__suffix-inner {
      .el-select__caret {
        font-family: 'element-icons' !important; // 确保使用 Element UI 的字体

        &.el-icon-arrow-up::before {
          content: "\e78f"; // 替换为你想用的 Element UI 图标的 Unicode 编码
        }

        &.el-icon-arrow-down::before {
          content: "\e790"; // 和展开时使用同一个图标的 Unicode
        }
      }
    }
  }
}
</style>
